import styled from 'styled-components';
import { MdInfoOutline } from 'react-icons/md';

const InfoIcon = styled(MdInfoOutline)`
  vertical-align: middle;
`;

export default InfoIcon;
